<div class="container">
  <div
    *ngIf="emptyTranslationsCount > 0"
    class="warning"
  >
    <ng-container *ngIf="!editingEmptyTranslations">
      <div class="label"><i class="fa fa-exclamation-triangle"></i>{{ emptyTranslationsCount }} item(s) are not translated in this language.</div>
      <eps-button
        buttonIcon="filter"
        label="Filter on empty items"
        (buttonClick)="filterOnEmptyTranslations()"
      ></eps-button>
    </ng-container>
    <eps-button
      buttonIcon="angle-left"
      label="Back to all items"
      (buttonClick)="clearFilter()"
      *ngIf="editingEmptyTranslations"
    ></eps-button>
  </div>
  <div>ALT + click on value to copy the default value</div>
  <div class="row">
    <div
      class="col-md-12"
      [hidden]="loading"
    >
      <json-editor
        [options]="editorOptions"
        [data]="editingEmptyTranslations ? jsonWithEmptyTranslations : json"
        (change)="changed.emit()"
        (mousemove)="mouseMove($event)"
        #editor
      ></json-editor>
    </div>
    <i
      class="fa fa-spinner fa-pulse fa-fw spinner-center"
      *ngIf="loading"
    ></i>
  </div>
</div>
<div
  class="defaultValue"
  *ngIf="defaultTranslation"
  [style]="defaultTranslationPosition"
>
  <div class="label">Default value:</div>
  <div class="value">{{ defaultTranslation }}</div>
</div>
<div
  class="row padding"
  style="padding-bottom: 50px"
>
  <div class="col-md-12">
    <eps-button
      buttonIcon="save"
      label="ADMIN.I18N.BUTTONS.SAVE"
      (buttonClick)="saveClicked()"
      [disabled]="!enableSave || loading || editingEmptyTranslations"
      [busy]="saving"
      *ngIf="!editingEmptyTranslations"
    ></eps-button>
    <eps-button
      buttonIcon="angle-left"
      label="Back to all items"
      (buttonClick)="clearFilter()"
      *ngIf="editingEmptyTranslations"
    ></eps-button>
    <div *ngIf="editingEmptyTranslations">
      {{ 'ADMIN.I18N.BUTTONS.BACK_TO_ALL_ITEMS.TOOLTIP' | translate }}
    </div>
  </div>
</div>
